import { Box, Button, Container, Stack, Typography } from "@mui/material";
import React from "react";
import TextField from "@mui/material/TextField";
import SendIcon from "@mui/icons-material/Send";
import { makeStyles } from "@mui/styles";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Avatar from "@mui/material/Avatar";
import useMediaQuery from "@mui/material/useMediaQuery";
import pdf from "./../../assets/cv.pdf";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const useStyles = makeStyles({
  inputStyle: {
    display: "flex",
    marginBottom: "20px",
  },
});

function Contact() {
  const classes = useStyles();

  const matches = useMediaQuery("(max-width:600px)");
  let size = "3x";
  const iconWidth = "30px";

  matches === true ? (size = "2x") : (size = "3x");

  return (
    <Container>
      <Stack>
        <h2>Wanna get in touch ?</h2>
        <Box>
          <Typography>Would you like to hire me?</Typography>
          <Button
            href={pdf}
            target="_blank"
            variant="contained"
            sx={{ marginTop: "5px" }}
            rel="noopener noreferrer"
          >
            Get My CV
          </Button>
        </Box>
        <p>You can Contact me on my social media</p>
        <Stack direction="row" spacing={1} mb={3}>
          <Button
            target="_blank"
            href="https://github.com/moatefdev"
            sx={{ minWidth: iconWidth }}
          >
            <i class={`fab fa-github fa-${size}`}></i>
          </Button>
          <Button
            target="_blank"
            href="https://twitter.com/mohamed_gt57"
            sx={{ minWidth: iconWidth }}
          >
            <i class={`fab fa-twitter fa-${size}`}></i>
          </Button>
          <Button
            target="_blank"
            href="https://www.linkedin.com/in/mohamedatefdev/"
            sx={{ minWidth: iconWidth }}
          >
            <i class={`fab fa-linkedin fa-${size}`}></i>
          </Button>
          <Button
            target="_blank"
            href="https://dev.to/mohamed_gt57"
            sx={{ minWidth: iconWidth }}
          >
            <i class={`fab fa-dev fa-${size}`}></i>
          </Button>
          <Button
            target="_blank"
            href="https://medium.com/@mohammedatef"
            sx={{ minWidth: iconWidth }}
          >
            <i class={`fab fa-medium fa-${size}`}></i>
          </Button>
          <Button
            target="_blank"
            href="https://www.instagram.com/mohamedatefdev/"
            sx={{ minWidth: iconWidth }}
          >
            <i class={`fab fa-instagram fa-${size}`}></i>
          </Button>
          {/* <Button target="_blank" href="https://github.com/moatefdev">
            <i class="fab fa-facebook fa-3x"></i>
          </Button> */}
        </Stack>
        <Box>
          <form
            action="https://formsubmit.io/send/jobs@mohamedatef.link"
            method="POST"
          >
            <TextField
              name="_redirect"
              type="hidden"
              id="name"
              value="https://mohamedatef.vercel.app/thanks"
            />

            <TextField
              className={classes.inputStyle}
              id="outlined-basic"
              label="Name"
              variant="outlined"
              name="name"
              required
            />
            <TextField
              className={classes.inputStyle}
              id="outlined-basic"
              label="Email"
              type="email"
              variant="outlined"
              name="email"
              required
            />
            <TextField
              className={classes.inputStyle}
              id="outlined-multiline-static"
              label="Message"
              multiline
              rows={4}
              name="message"
            />
            <TextField
              name="_formsubmit_id"
              type="text"
              style={{ display: "none" }}
            />

            <Button
              className={classes.inputStyle}
              variant="contained"
              endIcon={<SendIcon />}
              type="submit"
            >
              Send
            </Button>
          </form>
        </Box>
      </Stack>
    </Container>
  );
}

export default Contact;
